// M084 new stage
function initNewStage() {

    if ($(".newStage__play-button").length > 0) {
		$(".newStage__play-button").each(function(){
            $(this).click(function(){
                if($(this).hasClass("pause-icon")){
                    $(this).removeClass("pause-icon");
                    $(this).parent(".newStage").addClass("paused")
                }
                else{
                    $(this).addClass("pause-icon");
                    $(this).parent(".newStage").removeClass("paused")
                }
            });
            $(this).on("keydown", function(e){
                if(e.which && (e.which == 9 || e.which == 16)){
                    return;
                }
                $(this).trigger("click");
            });
        });
    }

    if ($(".newStage").length > 0) {
		$(".newStage").each(function(){
			
			if($(this).find(".newStage__image").length > 1){
				//set intervall for animation
				setInterval(showNextNewStageImage, 5000);
			}
		});
	}

}

function showNextNewStageImage(){
	$(".newStage").each(function(){

        if(!$(this).hasClass("paused")){
            var $a = $(this).find(".newStage__image.active");
            $a.removeClass("active");
            
            var $n = $a.next(".newStage__image");
            
            if($n.length == 0){
                $n = $(this).find(".newStage__image").first();
            }
            
            if($n.hasClass("invisible")){
                $n.removeClass("invisible");
                if (_blazy) {
                    _blazy.revalidate();
                }
            }
            $n.addClass("active");
            //console.log("n:" + $n.length);
        }
	});
}
